import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Percent, Receipt } from "lucide-react";

const TABS = [
  { to: "/admin/pricing-rules/markup",          label: "Markup Rules",     icon: Percent },
  { to: "/admin/pricing-rules/convenience-fees", label: "Convenience Fees", icon: Receipt },
];

export default function AdminPricingRulesLayout() {
  return (
    <div className="space-y-6" data-testid="admin-pricing-rules">
      <div>
        <h1 className="font-heading text-3xl font-semibold text-[var(--brand-accent)]">Pricing Rules</h1>
        <p className="text-slate-500 mt-1">
          Configure markup &amp; convenience fees applied on the <strong>base fare</strong>.
          Markup uses priority (highest wins per pax type). Convenience fees are summed.
        </p>
      </div>

      <div className="border-b border-slate-200 flex gap-1">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={`pricing-tab-${t.to.split("/").pop()}`}
            className={({ isActive }) =>
              "px-4 py-2.5 -mb-px border-b-2 text-sm font-medium flex items-center gap-2 transition " +
              (isActive
                ? "border-[var(--brand-primary)] text-[var(--brand-primary-dark)]"
                : "border-transparent text-slate-500 hover:text-[var(--brand-primary-dark)]")
            }
          >
            <t.icon className="w-4 h-4" /> {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
